import { TOOL_ACTION } from 'store/selectors/toolSelector';

export enum KEY {
  DRAW = '1',
  EDIT = '2',
  EDIT_EDGES = '3',
  DELETE_FACET = '4',
}

export const KEY_TO_ACTION: Record<KEY, TOOL_ACTION | null> = {
	[KEY.DRAW]: TOOL_ACTION.DRAW_FACET,
	[KEY.EDIT]: TOOL_ACTION.EDIT_FACET,
	[KEY.EDIT_EDGES]: TOOL_ACTION.EDIT_EDGES,
	[KEY.DELETE_FACET]: TOOL_ACTION.DELETE_FACET,
};
